// extracted by css-extract-rspack-plugin
export default {"renderer":"VMxisZ"};